import { render, staticRenderFns } from "./giftDialog.vue?vue&type=template&id=29f919cd&scoped=true"
import script from "./giftDialog.vue?vue&type=script&lang=js"
export * from "./giftDialog.vue?vue&type=script&lang=js"
import style0 from "./giftDialog.vue?vue&type=style&index=0&id=29f919cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f919cd",
  null
  
)

export default component.exports